import React, { useEffect } from "react";

const Modal = ({ children, onClose }) => {
  useEffect(() => {
    const bodyElement = document.body;
    bodyElement.style.overflow = "hidden";

    return () => {
      bodyElement.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 overflow-scroll">
      <div className="my-12 mx-auto max-w-5xl w-11/12 bg-white p-5 rounded-md">
        <div className="flex justify-end">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (onClose) {
                onClose();
              }
            }}
          >
            Close
          </a>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
